/**
 * Header Scroll Configuration
 * Customize scroll behavior settings
 */

// Wait for the header scroll controller to be available
document.addEventListener('headerScrollInit', (event) => {
  const controller = event.detail.controller;
  
  console.log('Header Scroll Config: Controller initialized successfully');
  
  // Test manual control
  window.testHeaderScroll = function() {
    console.log('Testing scroll down behavior...');
    controller.testScrollDown();
  };

  // Test reset state
  window.resetHeaderScroll = function() {
    console.log('Resetting header state...');
    controller.resetState();
  };
  
  console.log('Run testHeaderScroll() to test manual control');
  
  // You can customize the behavior here based on page type or other conditions
  const currentTemplate = document.body.className.match(/template-(\w+)/);
  const templateName = currentTemplate ? currentTemplate[1] : 'index';
  
  // Example: Disable scroll behavior on certain pages
  const disableScrollPages = ['cart', 'checkout'];
  if (disableScrollPages.includes(templateName)) {
    controller.disable();
    return;
  }
  
  // Example: Different settings for different breakpoints
  const updateSettingsForViewport = () => {
    const isMobile = window.innerWidth <= 767;
    const isTablet = window.innerWidth >= 768 && window.innerWidth <= 1023;
    
    if (isMobile) {
      // More aggressive hiding on mobile to save space
      controller.config.scrollThreshold = 3;
      controller.config.hideDelay = 0;
    } else if (isTablet) {
      // Balanced settings for tablet
      controller.config.scrollThreshold = 5;
      controller.config.hideDelay = 25;
    } else {
      // More gentle behavior on desktop
      controller.config.scrollThreshold = 8;
      controller.config.hideDelay = 50;
    }
  };
  
  // Apply initial settings
  updateSettingsForViewport();
  
  // Update settings on resize
  let resizeTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(updateSettingsForViewport, 100);
  });
  
  // Example: Custom behavior for specific user interactions
  document.addEventListener('megaMenuOpen', () => {
    // Force header visible when mega menu opens
    controller.forceShow();
  });
  
  // Example: Log scroll events for analytics (optional)
  if (window.gtag || window.dataLayer) {
    document.addEventListener('headerHidden', () => {
      // Track header hide events
      if (window.gtag) {
        gtag('event', 'header_hidden', {
          event_category: 'user_interaction',
          event_label: 'scroll_down'
        });
      }
    });
    
    document.addEventListener('headerShown', () => {
      // Track header show events  
      if (window.gtag) {
        gtag('event', 'header_shown', {
          event_category: 'user_interaction',
          event_label: 'scroll_up'
        });
      }
    });
  }
});

// Expose global configuration function for theme customization
window.configureHeaderScroll = function(options) {
  if (window.headerScrollController) {
    Object.assign(window.headerScrollController.config, options);
  }
};
